export default __webpack_public_path__ + "static/media/figma.90eb21ce.png";